import React from "react";
import { FaAward, FaCertificate, FaBuilding, FaCheckCircle, FaShieldAlt } from "react-icons/fa";

const Icons = [FaAward, FaCertificate, FaBuilding, FaCheckCircle, FaShieldAlt];

const BrandItemNew = ({ mediaWith }) => {
  return (
    <div className="brand-icons" style={{ width: "100%" }}>
      <div className="brand-icons-row">
        {Icons.map((Icon, idx) => (
          <div key={idx} className="brand-icon-item">
            <Icon className="brand-icon-svg" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandItemNew;
